import React from 'react';
import { Tabs } from 'antd';
import {
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import { GetTab } from '../directory/GetTab';
import { UploadTab } from '../directory/UploadTab';
import { DeleteTab } from '../directory/DeleteTab';

const { TabPane } = Tabs;

export const DirectoryServiceTab: React.FC = () => {
  return (
    <Tabs defaultActiveKey="get" tabPosition="left" className="sub-tabs">
      <TabPane
        tab={
          <span>
            <DownloadOutlined /> GET (Download)
          </span>
        }
        key="get"
      >
        <GetTab />
      </TabPane>
      <TabPane
        tab={
          <span>
            <UploadOutlined /> PUT (Upload)
          </span>
        }
        key="upload"
      >
        <UploadTab />
      </TabPane>
      <TabPane
        tab={
          <span>
            <DeleteOutlined /> DELETE
          </span>
        }
        key="delete"
      >
        <DeleteTab />
      </TabPane>
    </Tabs>
  );
};
